import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProductionCostComponent } from '@ops/module-two';

import {
  CreateProjectComponent,
  CreateProjectModule,
  DashboardComponent,
  DashboardModule,
} from '@ops/components';
import {
  SessionManagerService,
  ProjectManagerService,
  ItemGroupService,
  CostItemService,
  CommunicationManagerService,
  EnumService,
  LoadingService,
  LocalStorageService,
  LanguageLoaderService,
  ProjectFinanceService,
  BankAccountService,
  OpsSubscriptionModalService,
} from '@ops/shared-types';
import { CompanyFinanceService } from 'legacy/modules/module-four/src/lib/company-finance/company-finance.service';
import {
  OpsForgotPasswordComponent,
  OpsLoginComponent,
  OpsResetPasswordComponent,
} from '@ops/storybook';
import { NgxsModule } from '@ngxs/store';
import { SettingsEditState } from '@ops/services';
import { OpsRegisterComponent } from '../../modern/shared/storybook/src/lib/ops-register/ops-register.component';
import { VerifyEmailComponent } from '../../modern/shared/storybook/src/lib/verify-email/verify-email.component';
import { OpsWelcomeStripe } from '../../modern/shared/storybook/src/lib/ops-welcome-stripe/ops-welcome-stripe.component';
import { WelcomeComponent } from '../../modern/shared/storybook/src/lib/welcome/welcome.component';
import { RoleGuard } from './role-guard.interceptor';

export const routes: Routes = [
  {
    path: 'login',
    component: OpsLoginComponent,
  },
  {
    path: 'user/verify/:token',
    component: OpsRegisterComponent,
  },
  {
    path: 'user/resetPassword/:token',
    component: OpsResetPasswordComponent,
  },
  {
    path: 'forgot-password',
    component: OpsForgotPasswordComponent,
  },
  {
    path: 'verify',
    component: VerifyEmailComponent,
  },
  {
    path: 'welcome',
    component: WelcomeComponent,
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [RoleGuard],
    data: { roles: ['admin', 'staff', 'guest'] },
  },
  {
    path: 'create-project',
    component: CreateProjectComponent,
    canActivate: [RoleGuard],
    data: { roles: ['admin', 'staff'] },
  },
  {
    path: 'project-estimate',
    loadChildren: () =>
      import(
        '../../legacy/modules/module-one/src/lib/main-layout/main-layout.module'
      ).then((m) => m.MainLayoutModule),
    canActivate: [RoleGuard],
    data: { roles: ['admin', 'staff', 'guest'] },
  },
  {
    path: 'production-cost/:projectId/:itemId',
    component: ProductionCostComponent,
    canActivate: [RoleGuard],
    data: { roles: ['admin', 'staff', 'guest'] },
  },
  {
    path: 'production-cost/:projectId',
    component: ProductionCostComponent,
    canActivate: [RoleGuard],
    data: { roles: ['admin', 'staff', 'guest'] },
  },
  {
    path: 'project-finance',
    loadChildren: () =>
      import(
        '../../legacy/modules/module-four/src/lib/project-finance/project-finance.module'
      ).then((m) => m.ProjectFinanceModule),
    canActivate: [RoleGuard],
    data: { roles: ['admin', 'staff'] },
  },
  {
    path: 'company-finance',
    loadChildren: () =>
      import(
        '../../legacy/modules/module-four/src/lib/company-finance/company-finance.module'
      ).then((m) => m.CompanyFinanceModule),
    canActivate: [RoleGuard],
    data: { roles: ['admin', 'staff'] },
  },
  {
    path: 'subscription',
    component: OpsWelcomeStripe,
    canActivate: [RoleGuard],
    data: {
      roles: ['admin', 'staff', 'guest'],
    },
  },
  {
    path: 'stripe',
    component: OpsWelcomeStripe,
    canActivate: [RoleGuard],
    data: {
      roles: ['admin', 'staff', 'guest'],
    },
  },
  {
    path: 'settings',
    loadChildren: () =>
      import(
        '../../modern/shared/storybook/src/lib/ops-settings/ops-settings.module'
      ).then((m) => m.OpsSettingsModule),
    canActivate: [RoleGuard],
    data: { roles: ['admin', 'staff', 'guest'] },
  },
  // {
  //   path: 'registry',
  //   loadChildren: () =>
  //     import('../../legacy/modules/module-tree/src/lib/registry.module').then(
  //       (m) => m.RegistryModule
  //     ),
  // },
  {
    path: 'cashflow',
    loadChildren: () =>
      import(
        '../../legacy/modules/module-four/src/lib/cashflow/cashflow.module'
      ).then((m) => m.CashflowModule),
    canActivate: [RoleGuard],
    data: { roles: ['admin', 'staff'] },
  },
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '/login',
  },
];

@NgModule({
  imports: [
    CreateProjectModule,
    DashboardModule,
    RouterModule.forRoot(routes, {
      // useHash: true,
    }),
    NgxsModule.forRoot([SettingsEditState]),
  ],
  providers: [
    LocalStorageService,
    SessionManagerService,
    LanguageLoaderService,
    ProjectManagerService,
    ItemGroupService,
    CostItemService,
    CompanyFinanceService,
    ProjectFinanceService,
    BankAccountService,
    CommunicationManagerService,
    OpsSubscriptionModalService,
    EnumService,
    LoadingService,
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
